<div class="quick-actions">
  <ng-template ngxPermissionsOnly="accessToChatModule">
    <button
      [hidden]="!currentUser.agent || filteredView"
      ktTwixor
      id="kt_twixor_toggle"
      data-toggle="tooltip"
      data-placement="left"
      ngbTooltip="Start Chat"
      class="btn btn-sm btn-pill btn-icon btn-light btn-hover-danger position-relative"
    >
      <i class="flaticon2-chat-1 text-danger"></i>
      <span id="chatCountBadge" class="notification-badge">
        <span id="chatCount" class="notification-badge__count"></span>
      </span>
    </button>
  </ng-template>
  <div class="toggling-actions">
    <div
      data-toggle="tooltip"
      data-placement="left"
      ngbTooltip="Quick Actions"
      class="quick-actions-icon bg-warning mb-4"
    >
      <i class="fa fa-bolt"></i>
    </div>
    <ng-template ngxPermissionsOnly="accessContextualHistory">
      <button
        [hidden]="!(showTimelineIcon$ | async)"
        id="kt_timeline_toggle"
        data-toggle="tooltip"
        data-placement="left"
        ngbTooltip="Timeline"
        class="btn btn-sm btn-icon btn-light btn-hover-success mb-2"
        (mousedown)="loadTimeline()"
      >
        <i style="font-size: 12px !important" class="fa fa-project-diagram text-success"></i>
      </button>
    </ng-template>
    <ng-template ngxPermissionsOnly="canAddNote">
      <button
        data-toggle="tooltip"
        data-placement="left"
        ngbTooltip="New Note"
        class="btn btn-sm btn-icon btn-light btn-hover-primary mb-2"
        (mousedown)="createNote()"
      >
        <i class="flaticon-notes text-primary"></i>
      </button>
    </ng-template>
    <ng-template ngxPermissionsOnly="canAddTask">
      <button
        data-toggle="tooltip"
        data-placement="left"
        ngbTooltip="New Task"
        class="btn btn-sm btn-icon btn-light btn-hover-warning mb-2"
        (mousedown)="createTask()"
      >
        <i class="flaticon2-notepad text-warning"></i>
      </button>
    </ng-template>
    <ng-template ngxPermissionsOnly="canSendNotification">
      <button
        data-toggle="tooltip"
        data-placement="left"
        ngbTooltip="Send Message"
        class="btn btn-sm btn-icon btn-light btn-hover-info mb-2"
        (mousedown)="sendMessage()"
      >
        <i class="flaticon2-send-1 text-info"></i>
      </button>
    </ng-template>
  </div>
</div>
